import { Table, Button } from 'antd';
import React, { Component } from 'react';
import { columns6 } from './data';

class index extends Component {
    render() {
        const { data, print, onExport } = this.props;
        return (
            <div>
                <div className="table-title">Lobby Bar Key Performance Indicator 大堂吧关键绩效指数</div>
                <Table
                    columns={columns6()}
                    dataSource={data.data6}
                    size="middle"
                    bordered
                    pagination={false}
                    id="table5_10_6"
                    className="content"
                    scroll={print ? {} : { x: 3350, y: false }}
                    rowKey={v => v.sort}
                />
                {print ? null : <Button
                    className='export-btn'
                    type="primary"
                    onClick={() => onExport('table5_10_6', 'Lobby Bar Key Performance Indicator 大堂吧关键绩效指数')}
                    loading={print}
                >导出Excel</Button>}
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/Table5_10_6.js